import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { Lock, Eye, EyeOff } from "lucide-react";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  if (user && user.role === "admin") return <Navigate to="/admin" replace/>;

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      console.error("Login failed:", err);
      if (err.response?.data?.detail) {
        setErr(err.response.data.detail);
      } else if (err.response?.data?.error) {
        setErr(err.response.data.error);
      } else if (err.message) {
        setErr(err.message);
      } else {
        setErr("Błąd logowania: Serwer nie odpowiedział poprawnie.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#2A2A2A] flex items-center justify-center px-5" data-testid="admin-login-page">
      <div className="w-full max-w-md bg-[#1F1F1F] border border-[#3a3a3a] p-10">
        <div className="flex items-center gap-3 mb-8">
          <Lock className="text-[#FFCC00]" size={26}/>
          <div>
            <div className="kicker">Panel administracyjny</div>
            <h1 className="font-display text-white text-3xl uppercase mt-1">Zaloguj się</h1>
          </div>
        </div>
        <form onSubmit={submit} className="space-y-4" data-testid="admin-login-form" autoComplete="off">
          <div>
            <label className="font-mono-acc text-[10px] uppercase text-white/60">Email</label>
            <input
              data-testid="admin-email-input"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoComplete="off"
              className="w-full mt-2 bg-[#2A2A2A] border border-[#3a3a3a] text-white px-4 py-3 focus:border-[#FFCC00] outline-none"
            />
          </div>
          <div>
            <label className="font-mono-acc text-[10px] uppercase text-white/60">Hasło</label>
            <div className="relative">
              <input
                data-testid="admin-password-input"
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                autoComplete="new-password"
                className="w-full mt-2 bg-[#2A2A2A] border border-[#3a3a3a] text-white px-4 py-3 focus:border-[#FFCC00] outline-none pr-12"
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-3 top-1/2 -translate-y-1/2 mt-1 text-white/40 hover:text-white"
                tabIndex="-1"
              >
                {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
              </button>
            </div>
          </div>
          {err && <div className="text-red-400 text-sm" data-testid="admin-login-error">{String(err)}</div>}
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="w-full bg-[#FFCC00] text-black font-display py-4 btn-brutal disabled:opacity-50"
          >
            {loading ? "..." : "ZALOGUJ"}
          </button>
        </form>
      </div>
    </div>
  );
}
